export default "__VITE_ASSET__RCylpcNa__"